export const INNER_PLANETS = [
  { id: 'SUN', name: 'Sun' },
  { id: 'MERCURY', name: 'Mercury' },
  { id: 'VENUS', name: 'Venus' },
  { id: 'EARTH', name: 'Earth' },
  { id: 'MARS', name: 'Mars' },
  { id: 'JUPITER', name: 'Jupiter' },
  { id: 'SATURN', name: 'Saturn' },
  { id: 'URANUS', name: 'Uranus' },
  { id: 'NEPTUNE', name: 'Neptune' },
  { id: 'PLUTO', name: 'Pluto' },
] as const

export type InnerPlanetId = (typeof INNER_PLANETS)[number]['id']
